module.exports = __webpack_public_path__ + "static/media/Sahan.c8b75ebd.jpg";